export default __webpack_public_path__ + "static/media/notify.2eec35db.mp3";